module.exports = __webpack_public_path__ + "static/img/expert.8bee4c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/expert.png
// module id = IGcS
// module chunks = 0